<template>
  <div>
    <h3 class="Contracts mt-30 mb-25">Container (Direct sales)</h3>
    <div class="bg-white py-40">
      <div class="row p-lg-0 p-20">
        <div class="col-lg-7 col-md-12 m-auto">
          <div class="form-group">
            <div class="form-row">
              <div class="col-lg-3 col-md-12">
                <label class="col-form-label">Container</label>
              </div>
              <div class="col-lg-7 col-md-12">
                <div class="form-group">
                  <div class="drop drop-inline drop-sm">
                    <div class="cont">
                      <img alt=""
                           src="@/assets/img/icons/upload1.svg">
                      <div v-if="!containerForm.file.tsync_id" class="desc"> Upload Excel File</div>
                      <div v-if="containerForm.file.tsync_id" class="desc">{{ containerForm.file.name }}</div>
                    </div>
                    <input ref="fileUploader" accept=".xls, .xlsx"
                           type="file"
                           @change="onExcelChange($event)" @click="resetFileUploader">
                    <div
                      v-if="$v.$error & !$v.containerForm.file.tsync_id.required"
                      class="error">
                      An excel file is required.
                    </div>
                  </div>
                  <div class="d-inline-flex">
                    <i v-show="containerForm.file.tsync_id" aria-hidden="true"
                       class="fa fa-times ml-2 clear-file"
                       @click="clearFile(containerForm)"> Clear</i>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-md-12">
                <div class="text-right">
                  <div class="d-inline-flex">
                    <button v-if="!isObserverUser"
                            :disabled="!Object.keys(containerContents).length || !isSaveButtonActive"
                            class="btn btn-submit" type="button"
                            @click="saveContainer"> {{ saveButtonTxt }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group mb-30">
            <div class="row">
              <div class="col-12 col-md-12 col-lg-12 col-sm-12">
                <h4 v-show="fileLoading" class="text-warning">
                  <span v-show="!Object.keys(containerContents).length">
                    Excel is loading. Please wait a moment
                  </span>
                </h4>
                <h6 v-show="uploadPercentage"
                    :class="uploadPercentage === 100 ? 'text-success':'text-warning'">
                    <span v-show="uploadPercentage!==100">
                     Please don't close this TAB before the upload is 100% completed.
                    </span>
                </h6>
                <div v-show="uploadPercentage && uploadPercentage!==100" class="progress">
                  <div :style="'width: '+uploadPercentage+'%'" aria-valuemax="100"
                       aria-valuemin="0" aria-valuenow="1" class="progress-bar progress-bar-striped bg-success"
                       role="progressbar">{{ uploadPercentage }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row p-lg-0 p-20">
        <div class="col-md-12">
          <div class="p-3">
            <Table
              :api-prefix="apiPrefix"
              :committed-store="'setTraceabilityContainerContent'"
              :dispatched-store="'getContainersFromServer'"
              :is-data-fetched="loading"
              :table-data="tableData"
              :table-headers="tableHeaders"
              :table-search-config="tableSearchConfig"
              @updatedTableContents="getTableData"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormMixin from '@/mixins/form-mixin'
import { validationMixin } from 'vuelidate'
import UtilityMixin from '@/mixins/utility-mixin'
import { required } from 'vuelidate/lib/validators'
import xlsx from 'xlsx'
import Table from '@/components/admin/traceability/Table'
import moment from 'moment'
import { ContentTypes } from '@/config/constants'
import Menus from '@/config/menus'
import _ from 'lodash'

export default {
  name: 'AllCountryContainer',
  components: { Table },
  data () {
    return {
      containerForm: {
        file: {
          file: null,
          name: null,
          tsync_id: null
        }
      },
      containerContents: {},
      tableHeaders: [
        {
          title: 'Customer ID',
          subtitle: ''
        },
        {
          title: 'Customer',
          subtitle: ''
        },
        {
          title: 'Importer ID',
          subtitle: ''
        },
        {
          title: 'Importer',
          subtitle: ''
        },
        {
          title: 'Contract',
          subtitle: 'No'
        },
        {
          title: 'Shipment',
          subtitle: ''
        },
        {
          title: 'Bill',
          subtitle: 'Of Lading'
        },
        {
          title: 'Container',
          subtitle: 'No'
        },
        {
          title: 'ICO',
          subtitle: 'Lot'
        }
      ],
      tableSearchConfig: [
        {
          header: 'Customer ID',
          db_representation: 'bill_of_lading__contract__customer__public_code',
          widget_type: 'text'
        },
        {
          header: 'Customer',
          db_representation: 'bill_of_lading__contract__customer__name',
          widget_type: 'text'
        },
        {
          header: 'Importer ID',
          db_representation: 'bill_of_lading__contract__importer__public_code',
          widget_type: 'text'
        },
        {
          header: 'Importer',
          db_representation: 'bill_of_lading__contract__importer__name',
          widget_type: 'text'
        },
        {
          header: 'Contract No',
          db_representation: 'bill_of_lading__contract__contract_no',
          widget_type: 'text'
        },
        {
          header: 'Shipment',
          db_representation: 'bill_of_lading__contract__shipment__shipment_start_date__gte, bill_of_lading__contract__shipment__shipment_end_date__lte',
          widget_type: 'date_range'
        },
        {
          header: 'Bill Of Lading',
          db_representation: 'bill_of_lading__bill_of_lading_number',
          widget_type: 'text'
        },
        {
          header: 'Container No',
          db_representation: 'bill_of_lading__container_no',
          widget_type: 'text'
        },
        {
          header: 'ICO Lot',
          db_representation: 'ico_lot',
          widget_type: 'text'
        }
      ],
      searchDict: {
        searchField: '',
        searchText: '',
        date: '',
        fromDate: '',
        toDate: '',
        fromNumber: '',
        toNumber: ''
      },
      paginateDict: {
        nextUrl: null,
        previousUrl: null,
        currentPage: 1,
        totalPage: 1,
        firstPage: null,
        lastPage: null,
        remainingCount: 0,
        nextOffset: 0,
        totalCount: 0,
        dataPerPage: 5,
        previousPageNumber: 0,
        currentPageNumber: 0,
        nextPageNumber: 0
      },
      apiPrefix: 'v1/container',
      tableData: [],
      loading: false,
      fileLoading: false,
      fileTsyncIdMapping: {},
      loadingText: 'Excel is loading. Please wait a moment',
      isSaveButtonActive: true,
      saveButtonTxt: 'Submit',
      uploadPercentage: 0
    }
  },
  computed: {
    containersContent () {
      return this.$store.getters.getTraceabilityAllCountryContainerContents
    },
    containersTableData () {
      return this.getTableData()
    }
  },
  mixins: [FormMixin, validationMixin, UtilityMixin],
  validations: {
    containerForm: {
      file: {
        tsync_id: { required }
      }
    }
  },
  methods: {
    resetFileUploader () {
      // It reset image or file uploader if same file selected again
      this.$refs.fileUploader.value = ''
    },
    onExcelChange (e) {
      this.containerContents = {}
      if (e.target.files.length > 0) {
        const file = e.target.files[0]
        this.containerForm.file.file = file
        this.containerForm.file.name = file.name
        this.containerForm.file.tsync_id = this.uuidV4()
        this.fileLoading = false
        this.prepareContainerData()
        this.fileLoading = true
      } else {
        // if excel upload widget clicked and no file selected
        this.containerForm.file.file = null
        this.containerForm.file.name = null
        this.isChartPreviewed = false
        this.containerForm.file.tsync_id = null
      }
    },
    prepareContainerData () {
      if (this.containerForm.file.file) {
        const file = this.containerForm.file.file
        const fileReader = new FileReader()
        fileReader.onload = ev => {
          try {
            const data = ev.target.result
            const XLSX = xlsx
            const workbook = XLSX.read(data, {
              type: 'binary'
            })
            const wsname = workbook.SheetNames[0] // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
            const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname])

            const excelData = [] // Clear received data
            //
            const wsLength = ws.length
            for (var i = 0; i < wsLength; i++) {
              excelData.push(ws[i])
            }
            this.containerContents = excelData
          } catch (e) {
            return console.log('File can\'t read!')
          }
        }
        fileReader.readAsBinaryString(file)
      }
    },
    async saveContainer () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$notify({
          title: '',
          text: 'Please fix error(s) in form.',
          type: 'error',
          duration: 5000
        })
      } else {
        this.isSaveButtonActive = false
        this.saveButtonTxt = 'Submitting...'
        const vm = this

        // start file upload log
        const fileUploadLogPromises = []
        const response = this.createFileUploadLog(this.containerForm)
        fileUploadLogPromises.push(response)

        Promise.all(fileUploadLogPromises).then((values) => {
          const filePromises = []
          values.map((item) => {
            const fileId = item.data.file ? item.data.file.id : 0
            const fileTsyncId = item.data.file ? item.data.file.tsync_id : ''
            if (fileId === 0 || fileTsyncId === '') return
            const file = this.fileTsyncIdMapping[fileTsyncId]
            if (!file) return
            const response = this.uploadFile(fileId, file)
            filePromises.push(response)
          })
          Promise.all(filePromises).then((fileResponses) => {
            // this.$notify({
            //   title: '',
            //   text: 'File upload log created successfully.',
            //   type: 'success', // 'warn', 'error', 'success'
            //   duration: 5000
            // })
            this.$forceUpdate()
          })
        })
        // end file upload log

        let dataPosted = 0
        let dataNotPosted = 0
        const tempData = []

        const containerPromises = []
        let containerUploadCount = 0
        const totalContainer = _.size(vm.containerContents)
        const promises = await vm.containerContents.reduce(async (memo, v) => {
          await memo
          const response = vm.submitEachContainer(v)
          var myPromise = this.MakeQuerablePromise(response)
          response.then(function (data) {
            if (myPromise.isFulfilled()) {
              containerUploadCount += 1
              vm.uploadPercentage = Math.ceil(containerUploadCount / totalContainer * 100)
            }
          })
          containerPromises.push(response)
        }, [])
        _.unset(promises, '')

        Promise.all(containerPromises).then((values) => {
          values.map((item) => {
            const data = item.data
            if (data.success) {
              if (!_.get(data, 'results')) {
                tempData.push(data)
              } else {
                this.$store.commit('setTraceabilityContainerContent', data.results)
              }
              dataPosted += 1
            } else {
              this.$notify({
                title: 'Container',
                text: data.message,
                type: 'error', // 'warn', 'error', 'success'
                duration: 10000
              })
              dataNotPosted += 1
              vm.errorLog(item)
            }
          })
          this.isSaveButtonActive = true
          this.saveButtonTxt = 'Submit'

          if (tempData.length > 0) {
            vm.$store.commit('setTraceabilityContainerContent', tempData)
            this.getTableData(tempData)
          }
          if (dataNotPosted > 0) {
            this.$notify({
              title: 'Container',
              text: `${dataNotPosted} container not created/ updated.`,
              type: 'error'
            })
          }
          if (dataPosted > 0) {
            this.$notify({
              title: 'Container',
              text: `${dataPosted} container created/ updated successfully.`,
              type: 'success', // 'warn', 'error', 'success'
              duration: 5000
            })
          }
        })
      }
    },
    getTableData (payload) {
      if (payload) {
        payload = this.$store.getters.getTraceabilityAllCountryContainerContents
      }
      this.tableData = []
      for (const _data of payload) {
        const tempData = []
        const billOfLading = _.get(_data, 'bill_of_lading') || null

        tempData.push(_.get(billOfLading, 'contract.customer.public_code') || 'N/A')
        tempData.push(_.get(billOfLading, 'contract.customer.name') || 'N/A')
        tempData.push(_.get(billOfLading, 'contract.importer.public_code') || 'N/A')
        tempData.push(_.get(billOfLading, 'contract.importer.name') || 'N/A')
        tempData.push(_.get(billOfLading, 'contract.contract_no') || 'N/A')
        const shipmentStart = _.get(billOfLading, 'contract.shipment_start_date') || null
        const shipmentEnd = _.get(billOfLading, 'contract.shipment_end_date') || null
        if (shipmentStart && shipmentEnd) {
          tempData.push(moment(shipmentStart).format('DD.MM.YYYY') + ' - ' + moment(shipmentEnd).format('DD.MM.YYYY'))
        } else {
          tempData.push('N/A')
        }

        tempData.push(_.get(billOfLading, 'bill_of_lading_number') || 'N/A')
        tempData.push(_.get(_data, 'container_no') || 'N/A')
        tempData.push(_.get(_data, 'ico_lot') || 'N/A')
        this.tableData.push(tempData)
      }
      return this.tableData
    },
    async submitEachContainer (data) {
      const formData = this.$_.cloneDeep(data)
      return await this.$store.dispatch('createOrUpdateTraceabilityContainerContent', formData)
    },
    async createFileUploadLog (data) {
      const formData = this.$_.cloneDeep(data)
      const fileTsyncId = (formData.file && formData.file.tsync_id) ? formData.file.tsync_id : this.uuidV4()
      this.fileTsyncIdMapping[fileTsyncId] = data.file.file
      if (this.containerForm.file.file) {
        if (!formData.id) {
          formData.file = {
            tsync_id: fileTsyncId,
            extension: formData.file.name.split('.').pop()
          }
        } else {
          try {
            formData.file.extension = formData.file.name.split('.').pop()
          } catch (e) {

          }
        }
      }
      formData.content_type = ContentTypes.FILE
      formData.content = this.$store.getters.getContentByAppModule(Menus.traceability.key).id
      return await this.$store.dispatch('createOrUpdateTraceabilityContents', formData)
    }
  },
  watch: {
    containersContent: {
      deep: true,
      handler (newValue) {
        this.containers = _.cloneDeep(newValue)
      }
    }
  },
  created () {
    window.onbeforeunload = () => (this.uploadPercentage ? true : null)
  }
}
</script>

<style lang="scss" scoped>

.clear-file {
  cursor: pointer;
}

.drop-sm {
  padding-right: 60px !important;
  max-width: 100%; // if file name is long than it wont overflow next close button
}
</style>
